// Cross-context invalidation for the product-pricing cache.
//
// The same `blended_products` rows are fetched independently by two providers:
// IngredientsContext (admin surfaces, and every write path) and ProductsContext
// (the calculator and quote builder, read-only). Admin writes only refreshed the
// first, so the two copies diverged for the rest of the session: archiving a
// product left it in the quote-builder dropdown, and an ingredient cost edit left
// the quote priced off the old cost. Writers call notifyProductsChanged();
// ProductsContext subscribes and refetches.
//
// Ingredient writers publish too, not just product ones — ProductsContext derives
// PRODUCT_NANO_COSTS and PRODUCT_NANO_SHIPPING from the ingredient rows nested in
// the blended-product payload, so an ingredient edit moves quote pricing.
//
// Same-tab only, deliberately: both surfaces live in one SPA session. Mirrors the
// CustomEvent half of `roleOverride.js`, without the localStorage persistence.
const CHANGE_EVENT = 'products-changed';

export function notifyProductsChanged() {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(CHANGE_EVENT));
}

// Returns an unsubscribe fn.
export function subscribeProductsChanged(handler) {
  if (typeof window === 'undefined') return () => {};
  window.addEventListener(CHANGE_EVENT, handler);
  return () => window.removeEventListener(CHANGE_EVENT, handler);
}
